import React from 'react';

type Props = React.SVGProps<SVGSVGElement>;

const DashboardIcon = (props: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 24 24" {...props}>
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      >
        <path d="M10 13a2 2 0 1 0 4 0a2 2 0 1 0-4 0m3.45-1.45L15.5 9.5" />
        <path d="M6.4 20a9 9 0 1 1 11.2 0z" />
      </g>
    </svg>
  );
};

export default DashboardIcon;
